import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const closing = document.getElementById('comprar');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const closingTop = closing ? closing.getBoundingClientRect().top : Number.POSITIVE_INFINITY;

      // Show after scrolling past the hero, hide once the final price section is in view.
      const pastHero = heroBottom < 0;
      const atPrice = closingTop < window.innerHeight * 0.9;
      setVisible(pastHero && !atPrice);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-84" data-mp="33j7cwqlp7611">
      {visible && <motion.a href="#comprar" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-[#B8FF4C] text-[15px] font-extrabold text-[#24411D] shadow-[0_-4px_18px_-4px_rgba(184,255,76,0.5)] md:hidden" data-id="element-85" data-mp="33i5t9xqm9b7p">
          Obtener el acceso AHORA
        </motion.a>}
    </AnimatePresence>;
}